import { isWebM } from "../utils";
import { cn } from "@/lib/utils";

interface PortraitMediaProps {
  src: string;
  alt: string;
  className?: string;
}

/** Renders an image or auto-playing video depending on file type. */
export default function PortraitMedia({ src, alt, className }: PortraitMediaProps) {
  if (isWebM(src)) {
    return (
      <video
        className={cn("object-cover", className)}
        src={src}
        autoPlay
        loop
        muted
        playsInline
      />
    );
  }
  return <img className={cn("object-cover", className)} src={src} alt={alt} />;
}
